let serialsTheme = document.getElementById('serial-block');
let birdsTheme = document.getElementById('bird-block');

if (serialsTheme !== null) {
  serialsTheme.addEventListener('click', ()=>{
    localStorage.setItem('theme', 'serials');
    window.location.href = './quiz-page.html';
  })
}

if (birdsTheme !== null) {
  birdsTheme.addEventListener('click', ()=>{
    localStorage.setItem('theme', 'birds');
    window.location.href = './quiz-page.html';
  })
}